import { render, staticRenderFns } from "./FacilityOnboardingHold.vue?vue&type=template&id=cb6ea85c&scoped=true"
import script from "./FacilityOnboardingHold.vue?vue&type=script&lang=js"
export * from "./FacilityOnboardingHold.vue?vue&type=script&lang=js"
import style0 from "./FacilityOnboardingHold.vue?vue&type=style&index=0&id=cb6ea85c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6ea85c",
  null
  
)

export default component.exports